// Transformation utilities for FormProduct → Product conversion
export {
  transformFormProducts,
  transformProduct,
  transformVariant,
  hasActiveConnections,
  getProductConnectionStatus,
} from "./form-product-to-product";

export type {
  TransformOptions,
  ProductConnectionStatus,
} from "./form-product-to-product";
